import _ from 'lodash'

const _addParamsToLocation = function (params, currentRoute, lastParams) {
  const mergedParams = Object.assign(currentRoute.query || {}, lastParams || {}, params)

  const stringifiedParams = _.compact(Object.keys(mergedParams).map(key => {
    return _.isNil(mergedParams[key]) ? '' : (Array.isArray(mergedParams[key]) ? mergedParams[key].map((o) => (`${encodeURIComponent(key)}=${encodeURIComponent(o)}`)).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(mergedParams[key])}`)
  })).join('&')

  // console.log('pushState modification: ', { currentRouteQuery: currentRoute.query, lastParams, params, mergedParams, stringifiedParams })
  window.history.pushState(
    {},
    null,
    currentRoute.path + (stringifiedParams ? '?' : '') + stringifiedParams + (window.location.hash && window.location.hash !== '#' ? window.location.hash : '')
  )

  return mergedParams
}

/**
 * @param {object} params
 * @param {object} params.paramsObj
 * @param {object} params.route
 * @param {object|undefined} [params.lastParams=undefined]
 * @returns {object}
 * @private
 */
function _updateQueryParams ({ paramsObj, route, lastParams }) {
  const updatedParamsObj = {}

  for (const key in paramsObj) {
    if (paramsObj[key] !== undefined && paramsObj[key] !== null && paramsObj[key] !== '') {
      updatedParamsObj[key] = paramsObj[key]
    } else if (lastParams?.[key]) {
      lastParams[key] = ''
    }
  }

  return _addParamsToLocation({ ...updatedParamsObj }, route, lastParams)
}

function _extractBaseNameFromFilePath (path) {
  const filename = String(path).split('/')
  return filename.length ? filename[filename.length - 1] : ''
}

export const addParamsToLocation = _addParamsToLocation
export const updateQueryParams = _updateQueryParams
export const extractBaseNameFromFilePath = _extractBaseNameFromFilePath
